import _isEmpty from 'lodash/isEmpty';
import debugWallet from '../helpers/debugWallet.js';
import applyTenantCalculatorConfigs from './applyTenantCalculatorConfigs.js';
import applyDrSettings from './applyDrSettings.js';
import updateCalculatorConfig from './updateCalculatorConfig.js';
import applyFallbackDrSettings from './applyFallbackDrSettings.js';
import buildPaymentCalculationUrl from './buildPaymentCalculationUrl.js';
async function modifyExternalConfig(externalConfig, listing) {
  let paymentCalculationFetcher = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  let drSettingsFetcher = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  let paymentIncentivesFetcher = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  let payments = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
  let config;
  const type = listing?.type || 'Used';
  let vehicleType = type[0].toUpperCase() + type.slice(1); // should be capitalized already, this is just in case

  if (vehicleType === 'Certified') {
    vehicleType = 'Used'; // 'Certified' is not a valid option in the DR settings API response
  }
  const {
    interactions: {
      hasUpdatedWallet = false,
      paymentEmphasis = false,
      hasOpenedWallet = false
    } = {}
  } = payments;
  const isWalletEnabled = hasUpdatedWallet || paymentEmphasis || hasOpenedWallet;
  let drSettings = {};
  const hasDrSettings = () => !(_isEmpty(drSettings) || drSettings?.error);

  // Accelerate or BOA Tenant
  if (externalConfig.ecommerce === 'Accelerate' || externalConfig.ecommerce === 'BOA') {
    let modifiedExternalConfig;

    // Setting the sponsor for BOA to update DRSettings endpoint URl
    const sponsor = externalConfig.sponsor ?? (externalConfig.ecommerce === 'BOA' ? 'boa' : undefined);

    // Fetch DR settings for this dealer
    drSettings = (await drSettingsFetcher.fetch(externalConfig?.dealerId, sponsor)) || {};
    debugWallet('UDS', 'DR Settings Payload', drSettings);
    debugWallet('UDS', 'External config', externalConfig);

    // Apply DR settings to the calculator configuration
    modifiedExternalConfig = hasDrSettings() ? await applyDrSettings(externalConfig, drSettings, vehicleType) : externalConfig;
    if (isWalletEnabled) {
      modifiedExternalConfig = await updateCalculatorConfig(payments, modifiedExternalConfig);
    }
    debugWallet('UDS', 'Config after applying DR Settings Payload', modifiedExternalConfig);

    // Overlay tenant defaults to any missing values
    config = await applyTenantCalculatorConfigs(modifiedExternalConfig, listing);

    // Apply default DR settings to any missing values
    config = applyFallbackDrSettings(config, vehicleType);
  } else {
    // Ecommerce and PSX tenant defaults
    config = await applyTenantCalculatorConfigs(externalConfig, listing);
  }

  // Build payment calculation URL if not already built
  if (!config?.paymentCalculationUrl && !config?.enableExternalPaymentFetch) {
    // Should be called only once to build URL
    config.paymentCalculationUrl = await buildPaymentCalculationUrl(config, listing, hasDrSettings() ? drSettings : {}, vehicleType);
  }
  return {
    ...config,
    paymentCalculationFetcher,
    paymentIncentivesFetcher
  };
}
export { modifyExternalConfig as default };
